export default function menuOpen() {
    const menu = document.querySelector('#main-nav');
    const toggle = document.querySelector('.menu-toggle');
    if (!menu || !toggle) return;

    const mobile = window.matchMedia('(max-width: 600px)');
    document.documentElement.classList.add('js');
    toggle.hidden = false;
    const setOpen = (open) => {
        menu.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
    };
    const sync = () => setOpen(!mobile.matches);
    sync();
    mobile.addEventListener('change', sync);
    toggle.addEventListener('click', () => setOpen(menu.hidden));
    menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && mobile.matches) {
            setOpen(false);
            toggle.focus();
        }
    });
}
